import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchMake'
})
export class SearchMakePipe implements PipeTransform {

  transform(makes: any, searchText: string){
    
    if (!searchText) {
      return makes; // Return the original array if search text is empty
    }
  
    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison
  
    return makes.filter((makes: any) => makes.make_name.toLowerCase().includes(searchText));
  }

}
